import styled from 'styled-components';
import { Tooltip, Typography } from '@mui/material';
import { ReactComponent as LockIcon } from '../../assets/16x16/lock-simple.svg';
import { Flex } from '../Flex';

const Wrapper = styled(Flex)`
  align-items: center;
  gap: 8px;
`;

const StyledLockIcon = styled(LockIcon)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.common.gray4};
  width: 14px;
  height: 14px;
`;

const Label = styled(Typography)`
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme }) => theme.palette.common.gray4};
`;

type RestrictedIndicatorProps = {
  label?: string;
  tooltip?: string;
};

const RestrictedIndicator = ({
  label = 'Restricted',
  tooltip = "You don't have access to this resource",
}: RestrictedIndicatorProps) => (
  <Tooltip title={tooltip} placement="top">
    <Wrapper>
      <StyledLockIcon />
      <Label>{label}</Label>
    </Wrapper>
  </Tooltip>
);

export default RestrictedIndicator;
